import { IContestStatus } from '../../types/global/generic.types';
import {
    IContest,
    IContestAward,
    IEventState,
    IProject,
    ISale,
    ISubmission,
    IUserSummary,
} from '../../types/global/helper';
import { IUser } from '../../types/global/ListRender.types';
import { IInfluencer } from '../buzzbridge/types';
import { ILocation } from '../company/types';
import { ContestActivity, Like, ProjectActivity } from './model';

export const types = {
    CREATE_USER_PROFILE: 'CREATE_USER_PROFILE',
    CREATE_USER_PROFILE_SUCCESS: 'CREATE_USER_PROFILE_SUCCESS',
    CREATE_USER_PROFILE_FAILED: 'CREATE_USER_PROFILE_FAILED',

    SAVE_USER_DEVICE_TOKEN: 'SAVE_USER_DEVICE_TOKEN',
    SAVE_USER_DEVICE_TOKEN_SUCCESS: 'SAVE_USER_DEVICE_TOKEN_SUCCESS',
    SAVE_USER_DEVICE_TOKEN_FAILED: 'SAVE_USER_DEVICE_TOKEN_FAILED',

    REGISTER_CANCEL: 'REGISTER_CANCEL',

    PHONE_NUMBER_VERIFICATION: 'PHONE_NUMBER_VERIFICATION',
    PHONE_NUMBER_VERIFICATION_SUCCESS: 'PHONE_NUMBER_VERIFICATION_SUCCESS',
    PHONE_NUMBER_VERIFICATION_FAILED: 'PHONE_NUMBER_VERIFICATION_FAILED',

    GET_PHONE_VERIFICATION_CODE: 'GET_PHONE_VERIFICATION_CODE',
    GET_PHONE_VERIFICATION_CODE_SUCCESS: 'GET_PHONE_VERIFICATION_CODE_SUCCESS',
    GET_PHONE_VERIFICATION_CODE_FAILED: 'GET_PHONE_VERIFICATION_CODE_FAILED',

    START_EMAIL_FIELD_VERIFICATION: 'START_EMAIL_FIELD_VERIFICATION',
    EMAIL_FIELD_VERIFICATION_SUCCESS: 'EMAIL_FIELD_VERIFICATION_SUCCESS',
    EMAIL_FIELD_VERIFICATION_FAILED: 'EMAIL_FIELD_VERIFICATION_FAILED',

    START_PHONE_FIELD_VERIFICATION: 'START_PHONE_FIELD_VERIFICATION',
    PHONE_FIELD_VERIFICATION_SUCCESS: 'PHONE_FIELD_VERIFICATION_SUCCESS',
    PHONE_FIELD_VERIFICATION_FAILED: 'PHONE_FIELD_VERIFICATION_FAILED',

    START_EMAIL_FIELD_VERIFICATION2: 'START_EMAIL_FIELD_VERIFICATION2',
    EMAIL_FIELD_VERIFICATION_SUCCESS2: 'EMAIL_FIELD_VERIFICATION_SUCCESS2',
    EMAIL_FIELD_VERIFICATION_FAILED2: 'EMAIL_FIELD_VERIFICATION_FAILED2',

    START_PHONE_FIELD_VERIFICATION2: 'START_PHONE_FIELD_VERIFICATION2',
    PHONE_FIELD_VERIFICATION_SUCCESS2: 'PHONE_FIELD_VERIFICATION_SUCCESS2',
    PHONE_FIELD_VERIFICATION_FAILED2: 'PHONE_FIELD_VERIFICATION_FAILED2',

    START_USERNAME_FIELD_VERIFICATION: 'START_USERNAME_FIELD_VERIFICATION',

    USERNAME_AVAILABLE: 'USERNAME_AVAILABLE',
    USERNAME_TAKEN: 'USERNAME_TAKEN',
    USERNAME_FIELD_VERIFICATION_FAILED: 'USERNAME_FIELD_VERIFICATION_FAILED',
    USERNAME_FIELD_RESET: 'USERNAME_FIELD_RESET',

    GET_USER_PROFILE: 'GET_USER_PROFILE',
    GET_USER_PROFILE_SUCCESS: 'GET_USER_PROFILE_SUCCESS',
    GET_USER_PROFILE_FAILED: 'GET_USER_PROFILE_FAILED',
    RESET_USER_PROFILE: 'RESET_USER_PROFILE',

    UPDATE_USER_PROFILE: 'UPDATE_USER_PROFILE',
    UPDATE_USER_PROFILE_SUCCESS: 'UPDATE_USER_PROFILE_SUCCESS',
    UPDATE_USER_PROFILE_FAILED: 'UPDATE_USER_PROFILE_FAILED',

    GET_RESET_PASSWORD_TOKEN: 'GET_FORGOT_PASSWORD_TOKEN',
    GET_RESET_PASSWORD_TOKEN_SUCCESS: 'GET_FORGOT_PASSWORD_TOKEN_SUCCESS',
    GET_RESET_PASSWORD_TOKEN_FAILED: 'GET_FORGOT_PASSWORD_TOKEN_FAILED',

    RESET_PASSWORD: 'RESET_PASSWORD',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAILED: 'RESET_PASSWORD_FAILED',

    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILED: 'CHANGE_PASSWORD_FAILED',

    /** The below will be used to get the profile for any other use besides the user logged in */
    GET_A_USER_PROFILE: 'GET_A_USER_PROFILE',
    GET_A_USER_PROFILE_SUCCESS: 'GET_A_USER_PROFILE_SUCCESS',
    GET_A_USER_PROFILE_FAIL: 'GET_A_USER_PROFILE_FAIL',

    SEARCH_USER: 'SEARCH_USER',
    SEARCH_USER_SUCCESS: 'SEARCH_USER_SUCCESS',
    SEARCH_USER_FAIL: 'SEARCH_USER_FAIL',

    ADD_TEST_USER: 'ADD_TEST_USER',
    REMOVE_TEST_USER: 'REMOVE_TEST_USER',

    GET_CURRENT_USER_PROFILE: 'GET_CURRENT_USER_PROFILE',
    GET_CURRENT_USER_PROFILE_SUCCESS: 'GET_CURRENT_USER_PROFILE_SUCCESS',
    GET_CURRENT_USER_PROFILE_FAIL: 'GET_CURRENT_USER_PROFILE_FAIL',

    UPDATE_ACTIVITY_LIKE: 'UPDATE_ACTIVITY_LIKE',
    UPDATE_ACTIVITY_LIKE_SUCCESS: 'UPDATE_ACTIVITY_LIKE_SUCCESS',
    UPDATE_ACTIVITY_LIKE_FAILED: 'UPDATE_ACTIVITY_LIKE_FAILED',

    REMOVE_ACTIVITY_LIKE: 'REMOVE_ACTIVITY_LIKE',
    REMOVE_ACTIVITY_LIKE_SUCCESS: 'REMOVE_ACTIVITY_LIKE_SUCCESS',
    REMOVE_ACTIVITY_LIKE_FAILED: 'REMOVE_ACTIVITY_LIKE_FAILED',

    GET_TOP_USER: 'GET_TOP_USER',
    GET_TOP_USER_SUCCESS: 'GET_TOP_USER_SUCCESS',
    GET_TOP_USER_FAIL: 'GET_TOP_USER_FAIL',

    INITIATE_EMAIL_VERIFY: 'INITIATE_EMAIL_VERIFY',
    INITIATE_EMAIL_VERIFY_SUCCESS: 'INITIATE_EMAIL_VERIFY_SUCCESS',
    INITIATE_EMAIL_VERIFY_FAIL: 'INITIATE_EMAIL_VERIFY_FAIL',

    VERIFY_EMAIL: 'VERIFY_EMAIL',
    VERIFY_EMAIL_SUCCESS: 'VERIFY_EMAIL_SUCCESS',
    VERIFY_EMAIL_FAIL: 'VERIFY_EMAIL_FAIL',

    DISABLE_ACCOUNT: 'DISABLE_ACCOUNT',
    DISABLE_ACCOUNT_SUCCESS: 'DISABLE_ACCOUNT_SUCCESS',
    DISABLE_ACCOUNT_FAIL: 'DISABLE_ACCOUNT_FAIL',

    GET_USERS_DASHBOARD: 'GET_USERS_DASHBOARD',
    GET_USERS_DASHBOARD_SUCCESS: 'GET_USERS_DASHBOARD_SUCCESS',
    GET_USERS_DASHBOARD_FAIL: 'GET_USERS_DASHBOARD_FAIL',

    UPDATE_USER: 'UPDATE_USER',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_FAIL: 'UPDATE_USER_FAIL',

    ADMIN_UPDATE: 'ADMIN_UPDATE',
    ADMIN_UPDATE_SUCCESS: 'ADMIN_UPDATE_SUCCESS',
    ADMIN_UPDATE_FAIL: 'ADMIN_UPDATE_FAIL',

    UPDATE_USER_PERMISSIONS: 'UPDATE_USER_PERMISSIONS',
    UPDATE_USER_PERMISSIONS_SUCCESS: 'UPDATE_USER_PERMISSIONS_SUCCESS',
    UPDATE_USER_PERMISSIONS_FAIL: 'UPDATE_USER_PERMISSIONS_FAIL',
};

export interface IUpdateUser {
    role: string;
    userId: string;
}

export interface IAdminUpdate {
    category: 'audition' | 'contest' | 'award';
    id: string;
    payload: Record<string, any>;
}

export interface IAdminUpdateSuccess {
    category: 'audition' | 'contest' | 'award';
    updatedItem: any;
}

export interface IUpdateUserPermissions {
    userId: string;
    role: string;
    active: boolean;
    verified: boolean;
    permissions: string[];
    admin_note?: string;
}

export interface IUpdateUserPermissionsSuccess {
    updatedUser: UsersData;
}

export interface IGetTopUserPayload {
    user_type: string[];
}

export interface IWorkProfileSummary {
    feature_picture: string;
    profile_picture: string;
    profile_type: string;
    stage_name: string;
    _id: string;
}

export interface IUserSearchResult {
    _id: string;
    firstName: string;
    lastName: string;
    profile_picture?: string;
    userName: string;
    verified?: boolean;
    /** Will show up when with withJuryQuery and contestId are present in the search */
    invited?: boolean;
    profiles: IWorkProfileSummary[];
}

export interface ISearchUserPayload {
    searchTerm: string;
    withJuryQuery?: boolean;
    contestId?: string;
    /** Determines if we return user work profiles too */
    withProfileSearch?: boolean;
    /** Only return users with profiles */
    strict?: boolean;
}

export interface ISearchUserResponse {
    result: IUserSummary[];
    total_result_count: number;
}

export interface IGetUserProfile {
    /** This flag makes it that visually, the dashboard does not refresh while we are updating new content
     * Just incase a user s currently looking at it
     */
    isRefresh?: boolean;
}

export interface IVerifyEmail {
    token: string;
}

export interface ILikeActivityPayload {
    activity: ProjectActivity | ContestActivity;
    isExternalProfile: boolean;
    /** The below informs us what page this like is coming from. Allows us to clear proper cache */
    from?: string;
    /**The cache value to clear example the username on whose name this is being liked */
    cache?: string;
}

export interface IRemoveLikeActivity extends ILikeActivityPayload {
    like: Like;
}

export interface IDisableAccount {
    disable?: boolean;
}

export type TDashboardCategory =
    | 'revenue'
    | 'following'
    | 'subscription'
    | 'sales'
    | 'submissions'
    | 'application'
    | 'gigs'
    | 'events'
    | 'users'
    | 'requests'
    | 'reports'
    | 'campaigns'
    | 'tickets'
    | 'auditions'
    | 'contests'
    | 'awards';

export interface IDashboard {
    revenue: {
        data: RevenueData[];
        currentPage: number;
        pageSize: number;
        totalPages: number;
        total: number;
        monthToDateChange: number;
        loading: boolean;
        availableAmount?: number;
    };
    following: {
        currentPage: number;
        pageSize: number;
        totalFollowing: number;
        totalFollowers: number;
        loading: boolean;
        data: { following: Following2[]; followers: Follower[]; followerLocations: FollowerLocation[] };
    };
    subscription: {
        _id?: string;
        name?: string;
        amount?: number;
        interval?: string;
        plan_code?: string;
        limit?: number;
        currency?: string;
        created_at?: string;
        created_by?: string;
        source?: string;
        __v?: number;
        features?: string[];
        description?: string;
    };
    sales: {
        data: any[];
        currentPage: number;
        totalSales: number | string;
        totalCount: number;
        monthToDateChange: number;
        pageSize: number;
        totalPages: number;
        loading: boolean;
    };
    submissions: {
        data: ISubmission[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
        loading: boolean;
    };
    application: {
        data: ApplicationData[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
        loading: boolean;
    };
    gigs: {
        data: GigsData[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
        loading: boolean;
    };
    events: {
        data: EventsData[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
        loading: boolean;
    };
    users: {
        data: UsersData[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
        loading: boolean;
    };
    requests: {
        data: any[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
        loading: boolean;
    };
    reports: {
        data: ReportsData[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
        loading: boolean;
    };
    campaigns: {
        data: CampaignsData[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        loading: boolean;
        totalPages: number;
    };
    tickets: {
        data: TicketData[];
        currentPage: number;
        pageSize: number;
        totalCount: number;
        loading: boolean;
        totalPages: number;
    };
    auditions: Auditions;
    contests: Contests;
    awards: Awards;
}

export interface DashboardPagination {
    page?: number;
    limit?: number;
    category?: TDashboardCategory;
    skipRefresh?: boolean;
    searchTerm?: string;
}
export interface IUsersDashboard extends DashboardPagination {}
export interface IUsersDashboardPage {
    revenue: number;
    following?: number;
    subscription?: number;
    sales: number;
    submissions: number;
    application?: number;
    gigs?: number;
    events?: number;
    users: number;
    requests?: number;
    reports?: number;
    campaigns?: number;
}

export interface IUsersDashboardData {
    pagination?: DashboardPagination;
    revenue: Revenue;
    following: Following;
    subscription?: Subscription;
    sales: Sales;
    submissions: DashboardSubmissions;
    application?: Application;
    gigs?: Gigs;
    events?: Events;
    users: Users;
    requests?: Requests;
    reports?: Reports;
    campaigns?: Campaigns;
    tickets?: Tickets;
    auditions?: Auditions;
    contests?: Contests;
    awards?: Awards;
}

export interface ITransactionResponse {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalCount: number;
    data: ITransaction[];
    hasNextPage: boolean;
}

export interface ITransaction {
    _id: string;
    transaction_flow: string;
    amount: number;
    transaction_type: string;
    currency: string;
    initiating_account?: string;
    deleted: boolean;
    created_by: string;
    status?: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
    receiving_account?: string;
}

export interface Revenue {
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    total?: number;
    availableAmount: number;
    monthToDateChange?: number;
    data?: RevenueData[];
    transactions?: ITransactionResponse;
}

export interface IRevenueTransaction {
    transactionId: string;
    amount: number;
    currency: string;
    transactionType: string;
    createdAt: string;
}

export interface RevenueData {
    monthlyEarnings: number;
    percentageChange?: number;
    transactions?: IRevenueTransaction[];
    year: number;
    month: number;
}

export interface Award {
    category: string;
    event: Event;
    prize?: number;
}

export interface Event {
    name?: string;
    description?: string;
    genre?: string[];
    dates?: Date[];
    currency?: string;
}

export interface Date {
    phase: string;
    date_started: string;
    expiration_date: string;
    _id: string;
}

export interface Following {
    currentPage: number;
    pageSize: number;
    totalFollowing: number;
    totalFollowers: number;
    data: Data2;
}

export interface Data2 {
    following: Following2[];
    followers: Follower[];
    followerLocations: FollowerLocation[];
}

export interface Following2 {
    firstName: string;
    lastName: string;
    location: Location;
    userName: string;
    profile_picture?: string;
}

export interface Location {
    address: string;
    description: string;
    coordinates: number[];
    type: string;
}

export interface Follower {
    firstName: string;
    lastName: string;
    location: Location2;
    userName: string;
    profile_picture?: string;
}

export interface Location2 {
    address?: string;
    description?: string;
    coordinates: number[];
    type: string;
}

export interface FollowerLocation {
    _id: Id;
    totalFollowersInLocation: number;
    percentage: number;
}

export interface Id {
    coordinates: number[];
    address?: string;
}

export interface Subscription {
    _id: string;
    name: string;
    amount: number;
    interval: string;
    plan_code: string;
    limit: number;
    currency: string;
    created_at: string;
    created_by: string;
    source: string;
    __v: number;
    features: string[];
    description: string;
}

type TChart = {
    date: string;
    day: number;
    formatted_usd_total: string;
    month: number;
    salesCount: number;
    totalSales: number;
    usd_total: number;
    year: number;
};

export interface Sales {
    totalSales?: number;
    totalCount?: number;
    monthToDateChange?: number;
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    chart?: TChart[];
    data?: ISale[];
}

export interface DashboardSubmissions {
    currentPage?: number;
    pageSize?: number;
    totalCount?: number;
    totalPages?: number;
    data?: ISubmission[];
}

export interface Daum2 {
    _id: string;
    project: Project;
    contest: Contest;
    trending_marker: number;
    judging_status: string;
}

export interface Project {
    _id: string;
    title: string;
    project_type: string;
    total_likes: number;
    created_by: string;
    total_comments: number;
    video_id: string;
    metadata: Metadata;
    media_type: string;
    tag: string[];
    processing_complete: boolean;
    downloadable: boolean;
    thumbnail: string;
    feature_image: string;
    download_link: string;
    resolutions: Resolutions;
    hls?: string;
    description: string;
    hash_tags?: any[];
    transcript: string;
    vtt?: string;
}

export interface Metadata {
    duration: number;
    width: number;
    height: number;
    type: string;
}

export interface Resolutions {
    '360p': string;
    '480p': string;
    '720p': string;
    '1080p'?: string;
}

export interface Contest {
    _id: string;
    title: string;
    description: string;
    contest_media: any[];
    contest_video: IProject;
    voting_required: boolean;
    feature_image: string;
    voting_type: string;
    tag: string[];
    kind?: string;
    mobile_feature_image?: string;
}

export interface Application {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    data: ApplicationData[];
}

export interface ApplicationData {
    _id: string;
    role: string;
    audition: Audition;
    filing_status: string;
}

export interface Audition {
    _id: string;
    shoot_location: ShootLocation;
    created: string;
    attacthments: any[];
    tags: string[];
    submission_report: string;
    submissions: number;
    premiumAudition: boolean;
    title: string;
    production_company: string;
    company_website: string;
    rehearsal_date: string;
    casting_expiration: string;
    production_personel: string;
    synopsis: string;
    plot: string;
    compensation: boolean;
    slug: string;
    __v: number;
    submissions_total_count: number;
    yes: string[];
    file: File;
    created_by: string;
    attachment: string;
    audition_type: string;
    required_media: string[];
    status: string;
    saves: number;
    created_at: string;
    max_age: number;
    min_age: number;
    required_skill: string[];
    employment_type: string;
    reward_frequency: string;
    reward: number;
    attachment_description: string;
    attachment_type: string;
}

export interface ShootLocation {
    type: string;
    coordinates: number[];
    description: string;
    address: string;
}

export interface File {
    yes: any[];
}

export interface Gigs {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    data: GigsData[];
}

export interface GigsData {
    _id: string;
    title: string;
    casting_expiration: string;
    tags: string[];
    createdAt?: string;
    imageCover?: string;
    applicationStats?: any[];
    totalApplications?: number;
}

export interface Events {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    data: EventsData[];
}

export interface Contests {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalCount: number;
    phaseBreakdown: PhaseBreakdown[];
    statusBreakdown: StatusBreakdown[];
    mtdChanges: MtdChanges;
    data: SingleContest[];
}
export interface Awards {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalCount: number;
    statusBreakdown: StatusBreakdown[];
    yearBreakdown: YearBreakdown[];
    staffPickBreakdown: StaffPickBreakdown[];
    mtdChanges: MtdChanges;
    data: IContestAward[];
}

export interface StatusBreakdown {
    _id: string;
    count: number;
}

export interface StaffPickBreakdown {
    _id: any;
    count: number;
}

export interface YearBreakdown {
    _id: string;
    count: number;
}

export interface StatusBreakdown {
    _id: string;
    count: number;
}

export interface PhaseBreakdown {
    _id: string;
    count: number;
}

export interface StatusBreakdown {
    _id: string;
    count: number;
}

export interface SingleContest {
    _id: string;
    date_start: string;
    expiration_date: string;
    premium: boolean;
    contest_phase: string;
    status: string;
    title: string;
    description: string;
    feature_image?: string;
    is_feature?: boolean;
    slug: string;
    submissionCount: number;
    mobile_feature_image?: string;
    creator?: IUserSummary;
    project_phase?: string;
    with_fee?: boolean;
    approved?: boolean;
    funded?: boolean;
}

export interface Auditions {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalCount: number;
    currently_active: number;
    mtdChanges: MtdChanges;
    data: AuditionData[];
}

export interface MtdChanges {
    percentageChange: number;
    currentMonthCount: number;
}

export interface AuditionData {
    _id: string;
    title: string;
    location: ILocation;
    casting_expiration: string;
    tags: any[];
    createdAt: string;
    slug: string;
    imageCover?: string;
    currently_active: boolean;
    creator: IUserSummary;
    applicationCount: number;
    approved: boolean;
}

export interface EventsData {
    _id: string;
    name: string;
    event_start_date: string;
    event_end_date: string;
    feature_image: string;
    kind: string;
    tags: string[];
    createdAt: string;
    background_color: string;
    slug: string;
    with_fee: boolean;
    state: IEventState;
    cancelled_at: string;
    total_attendance: number;
    is_background_color: boolean;
    font_family: string;
    total_interest: number;
}

export interface IMTDChanges {
    currentMonthCount: number;
    percentageChange: number;
}
export interface Users {
    currentPage?: number;
    pageSize?: number;
    totalPages?: number;
    totalCount?: number;
    data: UsersData[];
    mtdChanges?: IMTDChanges;
}

export interface UsersData {
    _id: string;
    location: Location3;
    role: string;
    active?: boolean;
    phone_verified: boolean;
    email_verified: boolean;
    application_limit: number;
    casting_call_limit: number;
    audme_profile: string;
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    phoneNumber: number;
    profile_picture: string;
    stripeCustomerId?: string;
    paystack_customer_code?: string;
    identified: boolean;
    paystack_customer_id?: string;
    __v: number;
    current_subscription?: string;
    email_verify_token?: string;
    permissions: string[];
    user_type: string[];
    userName: string;
    visible: boolean;
    verified: boolean;
    interest: any[];
    home_town: HomeTown;
    updatedAt: string;
    attributes?: Attributes;
    pastWork?: PastWork;
    gender?: string;
    passwordChangedAt?: string;
    last_signed_in?: string;
    admin_note?: string;
}

export interface Location3 {
    address: string;
    description: string;
    coordinates: number[];
    type: string;
}

export interface HomeTown {
    coordinates: any[];
    type: string;
}

export interface Attributes {
    photos: any[];
    skills: any[];
}

export interface PastWork {
    demoReel: string[];
}

export type TRequestType =
    | 'account_verification'
    | 'contest_code'
    | 'account_deletion'
    | 'ad_approval'
    | 'access_request'
    | 'campaign_request'
    | 'payout'
    | 'initiate_campaign'
    | 'others'
    | 'influencer_request';
export interface IRequestsData {
    _id: string;
    request_type: TRequestType;
    request_status: string;
    user: string;
    created_by: Pick<
        IUser,
        | 'firstName'
        | 'lastName'
        | 'verified'
        | 'phoneNumber'
        | 'location'
        | 'email'
        | 'profile_picture'
        | 'userName'
        | 'phone_verified'
    >;
    metadata?: Metadata | IInitiateCamapignMetadata;
    resolved: boolean;
    deleted: boolean;
    createdAt: string;
    updatedAt: string;
    payout_amount?: number;
    payout_external_account?: string;
}

export interface ICampaignRequestMetaData {
    contest: IContest;
    influencer: IInfluencer;
}

export interface Metadata {
    campaign_name?: string;
    description?: string;
    requirements?: string[];
    currency?: string;
    campaign_budget?: number;
    displayCurrencyValue?: string;
    campaign_objective?: string;
    contest?: IContest;
    influencer?: IInfluencer;
    platforms?: string[];
    participant_count?: number;
}

export interface IInitiateCamapignMetadata {
    publishStatus: string;
    campaign_name: string;
    campaign_type: {
        label: string;
        value: string;
    };
    participant_count: {
        label: string;
        value: string;
    };
    campaign_budget: {
        label: string;
        value: string;
    };
    brand_name: string;
    industry: string;
    platforms: string[];
    campaign_objective: string;
}

export interface Requests {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalCount: number;
    data: IRequestsData[];
    mtdChanges?: IMTDChanges;
}

export interface Reports {
    currentPage: number;
    pageSize: number;
    totalPages: number;
    totalCount: number;
    data: ReportsData[];
    mtdChanges?: IMTDChanges;
}

export interface ReportsData {
    _id: string;
    report_type: string;
    resolution_status: string;
    created_at: string;
    deleted?: boolean;
    content: Content;
    report_description?: string;
    report_title: string;
    created_by: string;
    user: string;
    createdAt: string;
    updatedAt: string;
    __v: number;
}

export interface Content {
    type: string;
    model: string;
}

export interface Campaigns {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    data: CampaignsData[];
    mtdChanges?: IMTDChanges;
}

export interface Tickets {
    totalCount: number;
    pageSize: number;
    currentPage: number;
    totalPages: number;
    data: TicketData[];
}

export interface TicketData {
    _id: string;
    ticket_id: string;
    recipient_email: string;
    recipient_name: string;
    checked_in: boolean;
    checked_in_at: Date;
    seat_info: string;
    /** The saleId linked to this ticket */
    sale: string;
    // Flattened event details
    event_id: string;
    event_name: string;
    event_start_date: string;
    event_end_date: string;
    event_location: Location;
    event_feature_image: string;
    event_slug: string;
    // Flattened sale details
    sale_price: number;
    sale_currency: string;
    sale_exchange_rate: number;
    sale_invoice: object;
    receipt_url: string;
    refunded: boolean;
    // Formatted prices
    formatted_price: string;
    formatted_usd_price: string;
    usd_price: number;
    createdAt: string;
    can_refund: boolean;
}

export interface CampaignsData {
    _id: string;
    title: string;
    description: string;
    contest_phase_dates: ContestPhaseDate[];
    feature_image?: string;
    slug?: string;
    rating: string;
    premium: string;
    contest_phase: string;
    genre: string;
    status: IContestStatus;
    with_fee: boolean;
    approved: boolean;
    funded: boolean;
}

export interface ContestPhaseDate {
    _id: string;
    phase: string;
    date_started: string;
    expiration_date: string;
}

export interface Sale {
    price: number;
    transaction_currency: string;
    exchange_rate: number;
    invoice: Invoice;
}

export interface Invoice {
    id: string;
    object: string;
    amount: number;
    amount_captured: number;
    amount_refunded: number;
    application: any;
    application_fee: any;
    application_fee_amount: any;
    balance_transaction: string;
    billing_details: BillingDetails;
    calculated_statement_descriptor: string;
    captured: boolean;
    created: number;
    currency: string;
    customer: string;
    description: any;
    destination: any;
    dispute: any;
    disputed: boolean;
    failure_balance_transaction: any;
    failure_code: any;
    failure_message: any;
    fraud_details: FraudDetails;
    invoice: any;
    livemode: boolean;
    metadata: Metadata;
    on_behalf_of: any;
    order: any;
    outcome: Outcome;
    paid: boolean;
    payment_intent: string;
    payment_method: string;
    payment_method_details: PaymentMethodDetails;
    radar_options: RadarOptions;
    receipt_email: any;
    receipt_number: any;
    receipt_url: string;
    refunded: boolean;
    refunds: Refunds;
    review: any;
    shipping: any;
    source: any;
    source_transfer: any;
    statement_descriptor: any;
    statement_descriptor_suffix: any;
    status: string;
    transfer_data: any;
    transfer_group: any;
}

export interface BillingDetails {
    address: Address;
    email: any;
    name: string;
    phone: any;
    tax_id: any;
}

export interface Address {
    city: any;
    country: string;
    line1: any;
    line2: any;
    postal_code: any;
    state: any;
}

export interface FraudDetails {}

export interface Metadata {
    name: string;
    sale_id: string;
    billing_address: string;
}

export interface Outcome {
    advice_code: any;
    network_advice_code: any;
    network_decline_code: any;
    network_status: string;
    reason: any;
    risk_level: string;
    risk_score: number;
    seller_message: string;
    type: string;
}

export interface PaymentMethodDetails {
    card: Card;
    type: string;
}

export interface Card {
    amount_authorized: number;
    authorization_code: any;
    brand: string;
    checks: Checks;
    country: string;
    exp_month: number;
    exp_year: number;
    extended_authorization: ExtendedAuthorization;
    fingerprint: string;
    funding: string;
    incremental_authorization: IncrementalAuthorization;
    installments: any;
    last4: string;
    mandate: any;
    multicapture: Multicapture;
    network: string;
    network_token: NetworkToken;
    network_transaction_id: string;
    overcapture: Overcapture;
    regulated_status: string;
    three_d_secure: any;
    wallet: any;
}

export interface Checks {
    address_line1_check: any;
    address_postal_code_check: any;
    cvc_check: any;
}

export interface ExtendedAuthorization {
    status: string;
}

export interface IncrementalAuthorization {
    status: string;
}

export interface Multicapture {
    status: string;
}

export interface NetworkToken {
    used: boolean;
}

export interface Overcapture {
    maximum_amount_capturable: number;
    status: string;
}

export interface RadarOptions {}

export interface Refunds {
    object: string;
    data: any[];
    has_more: boolean;
    total_count: number;
    url: string;
}

export interface TicketEvent {
    _id: string;
    name: string;
    event_start_date: string;
    event_end_date: string;
    location: Location;
    feature_image: string;
    slug: string;
}

export interface Location {
    coordinates: number[];
    address: string;
    description: string;
    short_name: string;
    type: string;
}
